<template>
  <div data-testid="checkout-div-170" class="opc-pbx__byoc" @click='onContactSalesClick' v-html="$t('billing.pbx.bring_your_own_carrier', [contactSalesLink])"></div>
</template>
<script>
import { getPbxContactSalesLink } from '@/utils/i18n-shortcuts';
export default {
  name: 'AppealByoc',
  data() {
    return {
      contactSalesLink: getPbxContactSalesLink(),
    }
  },
  methods: {
    onContactSalesClick(event) {
      if (event?.target?.tagName === 'A') {
        this.$tracking.buyInteraction('zoom phone bring your own carrier', 'contact sales');
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.opc-pbx__byoc {
  font-style: normal;
  font-weight: 450;
  font-size: 14px;
  line-height: 150%;
  color: #666487;
  margin-top: 24px;
}
</style>
